import Config from "../../../env/config";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// import Button from "../../Button/Button";
// import AllIcons from "../../../Utility/IconLinks";

import "./HelpModal.scss";

const HelpModal = ({ HelpModalOpenModal, children, closeModal }) => {
  const CDN_URL = Config.CDN_URL;
  const { t } = useTranslation();
  const [lang] = useState(
    sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  );
  const isArabicLang = lang === 'ar';
    return (
        <>
          {HelpModalOpenModal && (
            <div className="HelpModalModalOverlay">
              <div className="HelpModalModalContent">
                <div className={isArabicLang ? "HelpModalCloseButton-ar" : "HelpModalCloseButton"}>
                  <button onClick={closeModal}>
                    <img
                      src={`${CDN_URL}modal_close_inc.webp`}
                      alt="close"
                    />
                  </button>
                </div>
                {children}
                <div className="HelpModalHeading">
                  <div className={isArabicLang ? "HelpTitle-ar" : "HelpTitle"}>{t("FOR_FURTHER_QUERIES_AND_ASSISTANCE")}</div>
                  <div className={isArabicLang ? "HelpContent-ar" : "HelpContent"}>
                    <div className="HelpEmail">
                      <div className="HelpEmailIcon">
                        <img src={`${CDN_URL}help_email_icon.webp`} alt="Mail Icon" width="100%" height="100%" />
                      </div>
                      <div className="HelpEmailTxt"><a href="mailto:support@tameen.om">{t("HELP_MODAL_SUPPORT_EMAIL")}</a></div>
                  </div>
                  <div className="HelpPhone">
                      <div className="HelpPhoneIcon">
                        <img src={`${CDN_URL}help_phone_icon.webp`} alt="Phone Icon" width="100%" height="100%" />
                      </div>
                      <div className="HelpNumTxt">{t("MODAL_SUPPORT_NUMBER")}</div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      );
    };

export default HelpModal;
